import React from 'react';
import { AlertTriangle, Clock, UserRound, X } from 'lucide-react';

export default function AppointmentConflictModal({ conflict, saving, onCancel, onConfirm }) {
  if (!conflict) return null;

  const conflicts = Array.isArray(conflict.conflicts) ? conflict.conflicts : [];

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-2xl">
        <div className="flex items-start justify-between border-b border-amber-200 bg-amber-50 p-5">
          <div className="flex items-start gap-3">
            <span className="rounded-full bg-amber-100 p-2 text-amber-700">
              <AlertTriangle className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-semibold text-gray-900">Conflito de horário</h3>
              <p className="mt-1 text-sm text-gray-600">
                Confira os agendamentos que ocupam este intervalo.
              </p>
            </div>
          </div>
          <button type="button" onClick={onCancel} disabled={saving} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="max-h-[55vh] space-y-3 overflow-y-auto p-5">
          {conflicts.map((item) => (
            <div key={item.id} className="rounded-lg border border-amber-200 bg-amber-50/50 p-4">
              <div className="flex items-center gap-2 font-medium text-gray-900">
                <UserRound className="h-4 w-4 text-amber-700" />
                {item.patient_name || 'Paciente não informado'}
              </div>
              <div className="mt-2 flex items-center gap-2 text-sm text-gray-700">
                <Clock className="h-4 w-4 text-gray-500" />
                {item.start_time || '—'} às {item.end_time || '—'}
              </div>
              <p className="mt-1 text-sm text-gray-600">
                {item.procedure || 'Procedimento não informado'} · {item.professional_name || 'Profissional não informado'}
              </p>
            </div>
          ))}

          <p className="text-sm text-gray-600">
            Se este for um encaixe ou atendimento simultâneo intencional, você pode continuar mesmo assim.
          </p>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-gray-200 bg-gray-50 p-4">
          <button type="button" onClick={onCancel} disabled={saving} className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 disabled:opacity-60">
            Cancelar
          </button>
          <button type="button" onClick={onConfirm} disabled={saving} className="rounded-lg bg-amber-600 px-4 py-2 text-sm font-medium text-white hover:bg-amber-700 disabled:opacity-60">
            {saving ? 'Agendando...' : 'Agendar mesmo assim'}
          </button>
        </div>
      </div>
    </div>
  );
}
